import { useCallback, useEffect, useMemo, useState } from 'react';
import { BzButton, BzCard, BzChip, BzInputText } from '../../../../../components';
import { Container, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from 'react-redux';
import { getFormattedNumbers, getMktSegIdFromApiExchangeName, handlePositionsChange } from '../../../../../utils/global_functions';
import { useWFHMessages } from '../../../../../hooks';
import { getWfhTouchlineLastTick } from '../../../../../redux/actions/wfh';
import { sendTouchlineRequest } from '../../../../../apis/web_socket';
import { FILTER_DISPLAY_OPTIONS, NET_POSITION_EXPIRY, SCRIP_INSTRUMENTS, SESSION_STORAGE_KEYS, TL_INDEX } from '../../../../../utils/global_variables';
import { Link, useNavigate } from 'react-router-dom';
import { handleModal, handleModalData } from '../../../../../redux/actions/modals';
import ZeroStates from '../../../../ZeroStates';
import { positionsFilter } from '../../../../../controllers/netPosition';
import { updateFilters } from '../../../../../redux/actions/orders';
import moment from 'moment';


const Overall = ({ handlePlaceOrder }) => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const overAllPositions = useSelector(state => state?.netPosition?.overAllPositions);
    const modalData = useSelector(state => state.modals?.modalData);
    const objFilterData = useSelector(state => state?.orders?.objFilterData);
    const [overallData, setOverallData] = useState([]);
    const [searchText, setSearchText] = useState();
    const [isSearchShoing, setIsSearchShowing] = useState(true);

    // const activeNetPositions = useSelector(state => state.netPosition.activeNetPositions);

    useEffect(() => {
        setOverallData(overAllPositions);
    }, [overAllPositions]);

    useEffect(() => {
        if (overAllPositions?.length > 0) {
            let arrScrips = overAllPositions?.map((each) => ({
                exchangeId: getMktSegIdFromApiExchangeName(each?.preferred_exchange),
                token: each?.preferred_scrip_token,
                isSubscribe: true
            }));
            sendTouchlineRequest(arrScrips);
        }
        return () => {
            if (overAllPositions?.length > 0) {
                let arrScrips = overAllPositions?.map((each) => ({
                    exchangeId: getMktSegIdFromApiExchangeName(each?.preferred_exchange),
                    token: each?.preferred_scrip_token,
                    isSubscribe: false
                }));
                sendTouchlineRequest(arrScrips);
            }
        };
    }, [overAllPositions]);

    // Azeem K : 01-04-2024 : BT-102298  Netposition Optamization – Start 
    const objOverAllPositionsIndexes = useSelector(state => state?.netPosition?.objOverAllPositionsIndexes);
    // Azeem K : 01-04-2024 : BT-102298  Netposition Optamization – End 

    const handleTodayPositions = useCallback((arrTouchLineData) => {
        // Azeem K : 01-04-2024 : BT-102298  Netposition Optamization – Start 
        let data = overallData;
        const arrMatchedPositions = objOverAllPositionsIndexes[arrTouchLineData[TL_INDEX.SEGMENT_ID] + '_' + arrTouchLineData[TL_INDEX.TOKEN]];
        if (arrMatchedPositions?.length > 0) {
            arrMatchedPositions?.forEach((nEachIndex) => {
                const positionsData = handlePositionsChange(overAllPositions[nEachIndex], arrTouchLineData);
                data[nEachIndex] = positionsData;
                setOverallData([...data]);
            });
        }
        // Azeem K : 01-04-2024 : BT-102298  Netposition Optamization – Start 
    }, [overAllPositions, overallData]);

    useWFHMessages('touchline', (e) => {
        handleTodayPositions(e.detail);
    });

    useEffect(() => {
        const objLastTickData = dispatch(getWfhTouchlineLastTick());
        if (Object.keys(objLastTickData).length > 0) {
            if (overAllPositions?.length > 0) {
                overAllPositions?.forEach((each) => {
                    const arrLastTickData = objLastTickData[each?.segment_id_token];
                    if (arrLastTickData?.length > 0) {
                        handleTodayPositions(arrLastTickData);
                    }
                });
            }
        }
    }, [overAllPositions, dispatch]);

    const onSearchChange = (value) => {
        setSearchText(value);
    };

    const onSearchClose = () => {
        setSearchText();
        setIsSearchShowing(true);
    };

    // Hari K:08-01-2024: BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings – NSE EQ -start
    const filteredData = useMemo(() => {
        if (modalData?.filter !== undefined) {
            if (Object?.keys(modalData?.filter)?.length > 0) {
                let filteredArray = positionsFilter(modalData?.filter, overallData);
                if (searchText?.length > 0) {
                    filteredArray = filteredArray?.filter((each) => each.title.toLowerCase().includes(searchText.toLowerCase()));
                }
                return filteredArray;
            } else { }
        } else { }
        if (overallData?.length > 0) {
            if (searchText?.length > 0) {
                const filteredPositions = overallData?.filter((each) => each.title.toLowerCase().includes(searchText.toLowerCase()));
                return filteredPositions;
            } else {
                return overallData;
            }
        } else { }
    }, [searchText, modalData, overallData]);
    // Hari K:08-01-2024: BT-107431 - Breeze - Watchlist Side Tray - Orders, Positions & Holdings – NSE EQ -end

    //Vaibhav SIngh: 08-03-24: overallData updated : Start
    const totalOverAllBuyValue = overallData.reduce((acc, item) => acc + (parseFloat(item?.cf_buy_value) === 0 ? parseFloat(item?.buy_value) : parseFloat(item?.cf_buy_value)), 0)?.toFixed(2);
    const totalOverAllSellValue = overallData.reduce((acc, item) => acc + (parseFloat(item?.cf_sell_value) === 0 ? parseFloat(item?.sell_value) : parseFloat(item?.cf_sell_value)), 0)?.toFixed(2);
    // const totalNetvalue = overallData.reduce((acc, item) => acc + ((parseFloat(item?.cf_buy_value) == 0 ? parseFloat(item?.buy_value) : parseFloat(item?.cf_buy_value)) - (parseFloat(item?.cf_sell_value) == 0 ? parseFloat(item?.sell_value) : parseFloat(item?.cf_sell_value))), 0)?.toFixed(2);
    const TodaysPL = overallData.reduce((acc, item) => acc + (parseFloat(item?.todays_pl)), 0)?.toFixed(2);
    const OverAllPL = overallData.reduce((acc, item) => acc + (parseFloat(item?.overAll_pl)), 0)?.toFixed(2);
    //  Azeem K:19-03-2024:BT-107422 :As per comment recieved from BA Realised, Unrealised, Todays and OverAll P/l % removed -Start
    //  Dont remove code it may be require later 
    // const todayPercentageChange = postionOverviewPercentageChange(TodaysPL, totalNetvalue);
    // const overAllPercentageChange = postionOverviewPercentageChange(OverAllPL, totalNetvalue);
    //  Azeem K:19-03-2024:BT-107422 :As per comment recieved from BA Realised, Unrealised, Todays and OverAll P/l % removed -End
    const allProductType = [...new Set(overAllPositions.map(element => element.product_type))];
    //Vaibhav SIngh: 08-03-24: overallData updated : End
    //Vaibhav Singh: 05-02-24: BT-107431: Updated Filter Lofic : Start
    const handleFilters = () => {
        if (overAllPositions?.length) {
            let segemntList = [];
            segemntList.push('All', 'All Combined');
            for (let c = 0; c < overAllPositions.length; c++) {
                if (segemntList.indexOf(overAllPositions[c].customSegment) === -1) {
                    segemntList.push(overAllPositions[c].customSegment) === -1;
                }
            }
            dispatch(handleModal([{ "FILTER_ORDER_POSITION_MODAL": true }]));
            dispatch(handleModalData({ type: 'Positions', allProductType: allProductType, segemntList: segemntList }));
        }
    };

    // const allExchangeList = [...new Set(overallData.map(element => element?.displayExchange))];

    const handleOrderHistory = (id) => {
        const path = `/orders?section=netPosition_Overall`;
        navigate(path, { state: id });
        sessionStorage.setItem(SESSION_STORAGE_KEYS.SEARCH_PARAMS, 'true');
    };
    const handleClickChips = (ele) => {
        delete objFilterData[ele];
        dispatch(handleModalData({ filter: objFilterData }));
        dispatch(updateFilters(objFilterData));
    };
    return (
        <>
            <Container fluid className='p-0 px-3'>
                <Row className='g-0 py-1 mb-2 align-items-center h_40'>
                    <Col md={4} className={`d-flex justify-content-start align-items-center ${overAllPositions?.length < 1 ? 'div-disabled' : ''}`}>
                        <Link to='/orders?section=squareOffOverall'>
                            <BzButton className='btn btn-sm btn-outline'>Square off All</BzButton>
                        </Link>
                    </Col>
                    <Col md={8} className='d-flex justify-content-end align-items-center'>
                        {isSearchShoing === true ?
                            <div onClick={() => overallData?.length > 0 ? setIsSearchShowing(false) : null} className={`icon-16 icon-search ${overallData?.length > 0 ? 'icon-dark' : 'icon-grey'}`}></div>
                            : <>
                                <div className='position-relative w-70'>
                                    <div className='icon-14 icon-search icon-grey search-icon-position'></div>
                                    <BzInputText autoFocus onChange={(e) => onSearchChange(e.target.value)} size='sm' type='search' placeholder="Search Scrips" className='p-l-30 font-regular scripname-searchtext'></BzInputText>
                                </div>
                                <div className='icon-16 icon-dark icon-close ms-2' onClick={() => onSearchClose()} />
                            </>
                        }
                        <div className={`icon-16 icon-searchfilter ${overAllPositions?.length ? 'icon-dark' : 'icon-grey'} ms-3`} onClick={handleFilters}></div>
                        <Link to='/orders?section=netPosition_Overall'>
                            <div className='icon-14 icon-redirect icon-dark ms-3'></div>
                        </Link>
                    </Col>
                </Row>
                {Object.keys(objFilterData)?.length ?
                    <Row className='g-0 mb-3'>
                        <Col className='d-flex'>
                            <div className='font-medium font-size3 color-text m-1'>Filters:</div>
                            <div className='horizontal-scroll-wrap filters-chips-wrap flex-nowrap'>
                                {Object.keys(objFilterData)?.map((ele, i) => {
                                    return <div key={i} className='chips chips default-chip text-capitalize m-1'>
                                        {objFilterData[ele] === "low_high" ? `${ele} : Low-High` : objFilterData[ele] === "high_low" ? `${ele} : High-Low` : parseFloat(objFilterData[ele]) ? `${ele.slice(-3)} : ${objFilterData[ele]}` : `${FILTER_DISPLAY_OPTIONS?.[ele] ? FILTER_DISPLAY_OPTIONS?.[ele] : ele} : ${objFilterData[ele]}`} <div style={{ width: "6px", height: '6px', marginLeft: "6px" }} onClick={handleClickChips?.bind(this, ele)} className='icon-16 icon-dark icon-close'></div>
                                    </div>;
                                })
                                }
                            </div>
                        </Col>
                    </Row>
                    : null
                }
                {/* //Vaibhav Singh: 05-02-24: BT-107431: Updated Filter Lofic : End */}
            </Container>
            {overallData?.length > 0 ?
                <Container fluid className='p-0'>
                    <div className='sticky-orderpositions-height px-3'>
                        <Row className='g-0 order-position-card-wrapper p-3 mb-2'>
                            <Row className='g-0 mb-3'>
                                <Col>
                                    <div className='font-regular font-size2 color-subtext text-capitalize'>Total Buy Value</div>
                                    <div className='font-medium font-size4 color-text'>&#8377;{getFormattedNumbers(totalOverAllBuyValue)}</div>
                                </Col>
                                <Col className='text-end'>
                                    <div className='font-regular font-size2 color-subtext text-capitalize'>Total Sell Value</div>
                                    <div className='font-medium font-size4 color-text'>&#8377;{getFormattedNumbers(totalOverAllSellValue)}</div>
                                </Col>
                            </Row>
                            <Row className='g-0'>
                                <Col>
                                    <div className='font-regular font-size2 color-subtext text-capitalize'>Today's P/L</div>
                                    <div className={`font-medium font-size3 color-text ${TodaysPL > 0 ? 'color-positive' : 'color-negative'}`}>&#8377;{getFormattedNumbers(TodaysPL)}
                                        {/* Azeem K:19-03-2024:BT-107422 :As per comment recieved from BA Realised, Unrealised, Todays and OverAll P/l % removed -Start
                                         Dont remove code it may be require later  */}
                                        {/* ({todayPercentageChange > 0 ? '+' : ''}{todayPercentageChange}%) */}
                                        {/* Azeem K:19-03-2024:BT-107422 :As per comment recieved from BA Realised, Unrealised, Todays and OverAll P/l % removed -End */}
                                    </div>
                                </Col>
                                <Col className='text-end'>
                                    <div className='font-regular font-size2 color-subtext text-capitalize'>OverAll P/L</div>
                                    <div className={`font-medium font-size3 color-text ${OverAllPL > 0 ? 'color-positive' : 'color-negative'}`}>&#8377;{getFormattedNumbers(OverAllPL)}
                                        {/* Azeem K:19-03-2024:BT-107422 :As per comment recieved from BA Realised, Unrealised, Todays and OverAll P/l % removed -Start
                                         Dont remove code it may be require later  */}
                                        {/* ({overAllPercentageChange > 0 ? '+' : ''}{overAllPercentageChange}%) */}
                                        {/* Azeem K:19-03-2024:BT-107422 :As per comment recieved from BA Realised, Unrealised, Todays and OverAll P/l % removed -End */}
                                    </div>
                                </Col>
                            </Row>
                        </Row>
                        <Row className='g-0'>
                            <Col>
                                <div className='p-0'>
                                    <div className='transparent-card-wrap'>
                                        {/* ManasaB : 10-09-2024 : Hotfix issue  - Start*/}
                                        {filteredData.length > 0 ? filteredData?.map((each, i) => (
                                            <BzCard key={i} className='transparent-card cursor-pointer bdr-btm' onClick={() => handleOrderHistory(each?.id)}>
                                                <Row className='g-0'>
                                                    <Col className='d-flex justify-content-start align-items-center'>
                                                        <div className='font-medium font-size3 color-text text-uppercase me-2'>{each?.title}</div>
                                                        {/* Vaibhav Singh: 20-02-24: Fixed issue with series: Start */}
                                                        <div className='d-flex'>
                                                            {
                                                                (each?.expiry_date && each?.strike_price && each?.strike_price > 0 &&
                                                                    each?.instrument) ?
                                                                    <div className='font-regular font-size2 color-subtext'>{`${moment(each?.expiry_date).format("DDMMMYYYY").toUpperCase().slice(0, 2)}  ${moment(each?.expiry_date).format("DDMMMYYYY").toUpperCase().slice(2, 5)} ${each?.strike_price} ${each?.option_type} `}</div> //Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings
                                                                    : (!each?.expiry_date && (!each?.strike_price || each?.strike_price <= 0) &&
                                                                        !each?.option_type) ?
                                                                        <div className='d-flex align-items-center'><div className='font-regular font-size2 color-subtext'>{each?.series}</div></div> //Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings
                                                                        : (each?.expiry_date && (!each?.strike_price || each?.strike_price <= 0)) ?
                                                                            <div className='font-regular font-size2 color-subtext'>{`${moment(each?.expiry_date).format("DDMMMYYYY").toUpperCase().slice(0, 2)} ${moment(each?.expiry_date).format("DDMMMYYYY").toUpperCase().slice(2, 5)} ${each?.instrument?.slice(0, 3)} `}</div> //Prachi T - 05-12-2023 - BT-109052 - Breeze- Font and Colour Settings
                                                                            : null
                                                            }
                                                        </div>
                                                        {/* Vaibhav Singh: 20-02-24: Fixed issue with series: End */}
                                                        <div className='d-flex align-items-center'>
                                                            {/* {dontMissData?.some(element => element[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN] === each?.segment_id_token)
                                                                ?
                                                                <div className='icon-16 icon-dontmiss icon-yellow float-start ms-2'></div> : null} */}
                                                            {/* {(holdingsScrips?.some(element => element?.nMarketSegmentId + '_' + element?.nToken === each?.segment_id_token) ?
                                                                <div className='icon-16 icon-portfolio icon-dark ms-2'></div> : null)}  */}
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row className='g-0'>
                                                    <Col className='d-flex justify-content-start'>
                                                        <div className='font-regular font-size2 color-text'>
                                                            <span className={`font-medium color-text ${each?.buy_quantity > each?.sell_quantity ? 'color-positive' : 'color-negative'}`}>{each?.buy_quantity > each?.sell_quantity ? 'BUY' : 'SELL'}: </span>{each?.net_quantity} @ ₹{each?.avg_buy_price}
                                                        </div>
                                                    </Col>
                                                    <Col className='d-flex justify-content-end'>
                                                        <div className='font-regular font-size2 color-text text-end'>
                                                            <span className='color-subtext'>LTP: </span> {each?.ltp}
                                                        </div>
                                                    </Col>
                                                </Row>
                                                <Row className='g-0'>
                                                    <Col md={4} className='d-flex justify-content-start align-self-center'>
                                                        <div className='chips-wrap'>
                                                            <BzChip className='chips primary-chip text-capitalize'>{each?.product_type}</BzChip>
                                                        </div>
                                                    </Col>
                                                    <Col md={8} className='d-flex justify-content-end align-self-center'>
                                                        <div className='font-regular font-size2 color-text text-end'>
                                                            <span className='color-subtext'>Today P/L: </span> <span className={`${parseFloat(each?.todays_pl) > 0 ? 'color-positive' : 'color-negative'}`}>{parseFloat(each?.todays_pl) > 0 ? '+' : ''}{each?.todays_pl}({parseFloat(each?.profit_loss) > 0 ? '+' : ''}{parseFloat(each?.profit_loss).toFixed(2)}%)</span>
                                                        </div>
                                                    </Col>
                                                </Row>
                                                {(each?.cf_net_price > 0 || each?.cf_sell_value > 0 || each?.cf_buy_value > 0) && each?.daily_or_expiry === NET_POSITION_EXPIRY.EXPIRY && (each?.instrument.substr(0, 3) === SCRIP_INSTRUMENTS.FUT || each?.instrument.substr(0, 3) === SCRIP_INSTRUMENTS.OPT) ?
                                                    <Row className='g-0'>
                                                        <Col md={6} className='d-flex justify-content-start'>
                                                            <div className='font-regular font-size2 color-text text-start'>
                                                                <span className='color-subtext'>Actual Price: </span> {each?.avg_buy_price}
                                                            </div>
                                                        </Col>
                                                        <Col md={6} className='d-flex justify-content-end'>
                                                            <div className='font-regular font-size2 color-text text-end'>
                                                                <span className='color-subtext'>Actual P/L: </span>
                                                                <span className={`${parseFloat(each?.overAll_pl) > 0 ? 'color-positive' : 'color-negative'}`}>{parseFloat(each?.overAll_pl) > 0 ? '+' : ''}{each?.overAll_pl}({each?.profit_loss})</span>
                                                            </div>
                                                        </Col>
                                                    </Row> : ''}
                                            </BzCard>
                                        )) :
                                            <div className='zero-state-alerts zero-state-alerts-xl'>
                                                <div className='icon-64 icon-nodata mrgauto mb-3'></div>
                                                <div className='font-medium font-size4 color-text mb-1'>No matches found</div>
                                                <div className='font-regular font-size2 color-nodata'>Try adjusting your search to find what you are looking for</div>
                                            </div>
                                        }
                                        {/* ManasaB : 10-09-2024 : Hotfix issue  -End*/}
                                    </div>
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Container>
                :
                //Vaibhav Singh: 05-02-24: BT-107431: ZeroStates Text uodated : Start
                <div className='zero-state-alerts zero-state-alerts-lg'>
                    <ZeroStates handleOnClick={handlePlaceOrder} subText="No Positions available" icon='icon-64 icon-nodata mb-3 mrgauto' btnText="Take a position today. Place an order." btnClass="btn btn-md btn-outline mt-2" />
                </div>
                //Vaibhav Singh: 05-02-24: BT-107431: ZeroStates Text uodated : End
            }
        </>
    );
};

export default Overall;